"use client"

import { IS_PRODUCTION_ENV } from "@src/utils/environment"
import Script from "next/script"

export function GoogleTagManager({
  gtmId,
  suppress,
}: {
  gtmId: string
  suppress: boolean
}) {
  if (!IS_PRODUCTION_ENV || suppress) return null

  const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`

  return (
    <Script id="gtm-bootstrap" strategy="afterInteractive">
      {script}
    </Script>
  )
}
